<template>
    <or-layout>
        <div>
            <a-spin :spinning="spinning">
                <div>
                    <a-row>


                        <a-col :span="4">
                            <a-select v-model="subject" @change="handleChangesubject" placeholder="学科"
                                style="width: 240px;padding-bottom: 10px;" allow-clear>
                                <a-select-option :value="0">全部</a-select-option>
                                <a-select-option :value="1">数学</a-select-option>
                                <a-select-option :value="2">英语</a-select-option>
                                <a-select-option :value="3">语文</a-select-option>
                                <a-select-option :value="4">化学</a-select-option>
                                <a-select-option :value="5">物理</a-select-option>
                            </a-select>

                            <a-select :v-model="grade_id" default-value="0" style="width: 120px"
                                @change="handleChangegrade">
                                <a-select-option value="0">
                                    全部年级
                                </a-select-option>
                                <a-select-option v-for="grade in gradelist" :key="grade.id">
                                    {{ grade.name }}
                                </a-select-option>
                            </a-select>

                            <a-select :v-model="semester_id" default-value="0" style="width: 120px"
                                @change="handleChangesemester">
                                <a-select-option value="0">
                                    全部学期
                                </a-select-option>
                                <a-select-option v-for="semester in semesterlist" :key="semester.id">
                                    {{ semester.name }}
                                </a-select-option>
                            </a-select>
                            <a-tree class="white-space-wrap" :show-line=true :show-icon=true :defaultExpandAll=true
                                @select="selectchapterItem" :treeData=basicChapterList :replaceFields=replaceFields>
                                <a-icon slot="icon" type="carry-out" />
                            </a-tree>
                        </a-col>
                        <a-col :span="20">
                            <a-tabs v-model="tab">
                                <a-tab-pane key="1" tab="试卷">
                                    <a-table :columns="columns" :data-source="chaptertestpaperlist"
                                        :pagination="testpaperpageinfo" @change="ontestpaperPaginationChange">
                                        <a slot="name" slot-scope="text">{{ text }}</a>
                                        <span slot="customTitle">
                                            <a-icon type="smile-o" /> Name
                                        </span>
                                        <span slot="action" slot-scope="text, record" >
                                           
                                            <a-divider type="vertical"/>
                                            <a v-if="record.typename !== '自我检测' && (record.typename !== '自我预习' || record.is_bind)" @click="showmal(record)">发布</a>

                                            <a-divider type="vertical" />
                                            <ViewExamModal :item="{ id: record.id }" />
                                           
                                            <!-- <a class="ant-dropdown-link" @click="showmal(record.id)">查看
                                            <a-icon type="down" />  </a>-->
                                        </span>
                                    </a-table>

                                    <a-modal :visible="visible" :width="1000" title="生成任务" @ok="okpostfrom"
                                        @cancel="handleCancel">
                                        <!-- {{ testpaper_info }} -->
                                        <a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                                            <a-form-item label="任务名称">
                                                <a-input v-model="from.mission_name" />
                                            </a-form-item>
                                            <a-form-item label="花名(标签)">
                                                <a-input v-model="from.tagname" />
                                            </a-form-item>
                                            <a-form-item label="根据班级时间顺延">
                                                <a-switch default-checked v-model="from.mission_fbtype" />
                                                (生成任务时候开始时间根据班级时段顺延)
                                            </a-form-item>
                                            <a-form-item label="年级">
                                                <a-tree-select treeNodeFilterProp="title" v-model="from.grade_id"
                                                    style="width: 100%" :treeData="gradelist"
                                                    :replaceFields="{ children: 'children', title: 'name', key: 'name', value: 'id' }"
                                                    placeholder="选择年级" tree-default-expand-all allowClear>
                                                </a-tree-select>
                                            </a-form-item>
                                            <a-form-item label="任务类型">
                                                <a-tree-select treeNodeFilterProp="title" v-model="from.type_id"
                                                    style="width: 100%" :treeData="missiontypelist"
                                                    :replaceFields="{ children: 'children', title: 'name', key: 'name', value: 'id' }"
                                                    placeholder="选择任务类型" tree-default-expand-all allowClear>
                                                </a-tree-select>
                                            </a-form-item>
                                            <a-form-item label="完成时间">
                                                <a-range-picker :show-time="{ format: 'HH:mm' }" format="YYYY-MM-DD HH:mm"
                                                    :placeholder="['开始时间', '结束时间']" @change="changeTimeRange"
                                                    @ok="changeTimeRange" />
                                            </a-form-item>

                                            <a-form-item label="检测任务名称" v-if="testpaper_info.is_bind === true">
                                                <a-input v-model="from.jcmission_name" />
                                            </a-form-item>

                                            <!-- {{ testpaper_info.is_bind_item.name }} -->
                                            
                                            <a-form-item label="检测试卷名称" v-if="testpaper_info.is_bind_item">
                                                <a-select v-model="from.jc_shijuan_id" 
                                                    style="width: 100%"
                                                    placeholder="检测试卷名称"
                                                    allowClear>
                                                    <a-select-option 
                                                        :value="testpaper_info.is_bind_item.id">
                                                        {{ testpaper_info.is_bind_item.name }}
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-item>
                                            <a-form-item label="是否计算班主任工资">
                                                <a-radio-group button-style="solid" v-model="jsbzrgz">
                                                    <a-radio-button :value="1">
                                                        计算
                                                    </a-radio-button>
                                                    <a-radio-button :value="0">
                                                        不计算
                                                    </a-radio-button>

                                                </a-radio-group>
                                            </a-form-item>

                                            <a-form-item label="是否限时">
                                                <a-radio-group button-style="solid" v-model="islimit">
                                                    <a-radio-button :value="0">
                                                        不限制
                                                    </a-radio-button>
                                                    <a-radio-button :value="1">
                                                        限制
                                                    </a-radio-button>

                                                </a-radio-group>
                                            </a-form-item>
                                            <a-form-item label="限制时间(分钟)">
                                                <a-input v-model="from.limit_time" />
                                            </a-form-item>
                                        </a-form>
                                    </a-modal>


                                    <a-modal :visible="visiblesettime" :width="1000" title="调整时间" @ok="setmissiontime"
                                        @cancel="settimehandleCancel">
                                        <a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">

                                            <a-form-item label="开始时间">
                                                <template>
                                                    {{ moment(settimeitem.start_time * 1000).format('lll') }}
                                                </template>
                                            </a-form-item>
                                            <a-form-item label="结束时间">
                                                <template>
                                                    {{ moment(settimeitem.end_time * 1000).format('lll') }}
                                                </template>
                                            </a-form-item>

                                            <a-form-item label="调整时间">
                                                <a-range-picker :show-time="{ format: 'HH:mm' }" format="YYYY-MM-DD HH:mm"
                                                    :placeholder="['开始时间', '结束时间']" @change="changesetTimeRange"
                                                    @ok="changesetTimeRange" />
                                            </a-form-item>

                                        </a-form>
                                    </a-modal>


                                    <a-modal :visible="visiblesetmissioninfo" :width="1000" title="修改信息"
                                        @ok="setmissionname" @cancel="setmissioninfoCancel">

                                        <a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                                            <a-form-item label="任务名称">
                                                <a-input v-model="setmissionfrom.name" />
                                            </a-form-item>
                                           <!-- <a-form-item label="花名(标签)">
                                                <a-input v-model="setmissionfrom.tagname" />
                                            </a-form-item> -->
                                          <!-- <a-form-item label="年级">
                                                <a-tree-select treeNodeFilterProp="title" v-model="setmissionfrom.grade_id"
                                                    style="width: 100%" :treeData="gradelist"
                                                    :replaceFields="{ children: 'children', title: 'name', key: 'name', value: 'id' }"
                                                    placeholder="选择年级" tree-default-expand-all allowClear>
                                                </a-tree-select>
                                            </a-form-item> -->

                                            <a-form-item label="任务类型">
                                                <a-tree-select treeNodeFilterProp="title" v-model="setmissionfrom.type_id"
                                                    style="width: 100%" :treeData="missiontypelist"
                                                    :replaceFields="{ children: 'children', title: 'name', key: 'name', value: 'id' }"
                                                    placeholder="选择任务类型" tree-default-expand-all allowClear>
                                                </a-tree-select>
                                            </a-form-item>
                                        </a-form>
                                    </a-modal>

                                </a-tab-pane>
                                <a-tab-pane key="2" tab="我的任务" force-render>
                                    <!--<a-form layout="inline">-->
                                    <!--<a-form-item >-->
                                    <!--<a-select-->
                                    <!--v-model="addDay"-->
                                    <!--placeholder="延期天数"-->
                                    <!--style="width: 100px;"-->
                                    <!--:loading="loading"-->
                                    <!--:disabled="true"-->
                                    <!--&gt;-->
                                    <!--<a-select-option-->
                                    <!--:key="1"-->
                                    <!--:value="1"-->
                                    <!--&gt;1天-->
                                    <!--</a-select-option>-->
                                    <!--<a-select-option-->
                                    <!--:key="2"-->
                                    <!--:value="2"-->
                                    <!--&gt;2天-->
                                    <!--</a-select-option>-->
                                    <!--<a-select-option-->
                                    <!--:key="3"-->
                                    <!--:value="3"-->
                                    <!--&gt;3天-->
                                    <!--</a-select-option>-->

                                    <!--</a-select>-->
                                    <!--</a-form-item>-->



                                    <!--<a-form-item>-->
                                    <!--<a-button type="primary" :loading="loading" htmlType="submit" icon="search" @click="getClassInfoList">搜索</a-button>-->
                                    <!--</a-form-item>-->
                                    <!--</a-form>-->
                                    <a-table :dataSource="chaptermissionlist" :rowKey="item => item.id"
                                        :pagination="missionpageinfo" @change="onmissionPaginationChange" bordered>
                                        <a-table-column key="name" title="任务名称" data-index="name" />
                                        <a-table-column key="mission_type_name" title="任务类型"
                                            data-index="mission_type_name" />
											<a-table-column key="create_name" title="创建人"
											    data-index="create_name" />
											
                                        <a-table-column key="tagname" title="标签" data-index="tagname" />



                                        <a-table-column key="status" title="状态">
                                            <template slot-scope="item">
                                                <a-tag v-if="item.publish === 1" color="#f50">
                                                    已发布
                                                </a-tag>
                                                <a-tag v-if="item.publish === 0" color="#2db7f5">
                                                    未发布
                                                </a-tag>

                                                <a-tag v-if="item.islimit === 1" color="purple">
                                                    <a-tooltip placement="topLeft">
                                                        <template slot="title">
                                                            <span>限时：{{ item.limit_time }}分钟</span>
                                                        </template>
                                                        限时任务
                                                    </a-tooltip>

                                                </a-tag>
                                                <a-tag v-if="item.mission_fbtype === 1" color="#33776f">
                                                    不同时
                                                </a-tag>
                                            </template>
                                        </a-table-column>


                                        <a-table-column key="create_time" title="开始时间">
                                            <template slot-scope="item">
                                                {{ moment(item.start_time * 1000).format('lll') }}
                                            </template>
                                        </a-table-column>
                                        <a-table-column key="end_time" title="结束时间">
                                            <template slot-scope="item">
                                                {{ moment(item.end_time * 1000).format('lll') }}
                                            </template>
                                        </a-table-column>
                                        <a-table-column key="testpaper" title="试卷">
                                            <template slot-scope="item">
                                                <ViewExamModal :item="{ id: item.examination_id }" />
                                            </template>
                                        </a-table-column>
                                        <a-table-column key="action" title="操作">
                                            <template slot-scope="text, record">
                                                <span>
                                                    <missionsquadmodel v-bind:itemdata="record"></missionsquadmodel>
                                                    <a-divider type="vertical" />
                                                    <squadlist @getsquad="getsquad" v-if="record.publish === 0"
                                                        v-bind:itemdata="record" buttinname="生成"></squadlist>

                                                    <a style="color:#009900;" v-if="record.publish === 1"
                                                        @click="qingkong(record.id)">清空</a>
                                                    <a-divider type="vertical" />

                                                    <a-tag v-if="record.mission_status === 2" color="#108ee9">
                                                        已结束
                                                    </a-tag>
                                                    <endmissionmodel @getsquad="getChapterMission" v-bind:itemdata="record"
                                                        v-if="record.mission_status === 1">
                                                    </endmissionmodel>
                                                    <a-dropdown :trigger="['click']">
                                                        <a-button size="small" type="link" icon="more" />
                                                        <a-menu slot="overlay">
                                                            <a-menu-item>
                                                                <a href="javascript:;" @click="settime(record)">调整时间</a>
                                                            </a-menu-item>
                                                            <a-menu-item>
                                                                <a href="javascript:;"
                                                                    @click="setmissioninfofunction(record)">修改任务信息</a>
                                                            </a-menu-item>
                                                            <a-menu-item>
                                                                <a href="javascript:;" @click="delmission(record.id)">删除</a>
                                                            </a-menu-item>
                                                        </a-menu>
                                                    </a-dropdown>
                                                </span>
                                            </template>
                                        </a-table-column>
                                    </a-table>
                                </a-tab-pane>
                            </a-tabs>
                        </a-col>
                    </a-row>
                </div>
            </a-spin>
        </div>
    </or-layout>
</template>

<script>
import moment from "moment";
import ViewExamModal from '@/views/testpaper/view-examl.vue';
import squadlist from '@/views/orgpublish/squadlist.vue';
import missionsquadmodel from '@/views/orgpublish/missionsquadmodel.vue';
import endmissionmodel from '@/views/orgpublish/endmissionmodel.vue';
//  import publishtestpaper from '@/views/orgpublish/publishtestpaper.vue';
const columns = [{
    title: '试卷名字',
    dataIndex: 'name',
    key: 'name',

},
{
    title: '试卷类型',
    dataIndex: 'typename',
    key: 'typename',

},
{
    title: '操作',
    key: 'action',
    scopedSlots: {
        customRender: 'action'
    },
},
];



export default {
    components: {
        ViewExamModal,
        squadlist,
        missionsquadmodel,
        endmissionmodel
    },

    data() {
        return {
            showLine: true,
            showIcon: false,
            chapter_id: '',
            settimeitem: [],
            visiblesettime: false,
            visiblesetmissioninfo: false,
            spinning: false,
            basicChapterList: [],
            grade_id: 0,
            subject: 0,
            semester_id: 0,
            from: [],
            testpaper_info:[],
            setmissionfrom: [],
            settimefrom: [],
            setmissioninfo: [],
            testpaper_id: '',
            islimit: 0,
            jsbzrgz: 1,
            gradelist: [],
            semesterlist: [],
            testpaperpageinfo: {
                total: 1,
                current: 1,
                pageSize: 10,
                allCnt: 0
            },
            missionpageinfo: {
                total: 1,
                current: 1,
                pageSize: 10,
                allCnt: 0
            },
            missiontypelist: [],
            replaceFields: {
                children: 'children',
                title: 'name',
                key: 'id'
            },
            visible: false,
            missionvisible: false,
            xx: '',
            tab: '1',
            //  Testpaperdata,
            columns,
            mission_id: [],
            squad_ids: [],
            chaptertestpaperlist: [],
            chaptermissionlist: [],

        };
    },
    mounted() {
        this.getBasicChapter();
        this.getgrade();
        this.getsemester();
        // this.getChapterTestpaper();
    },
    methods: {

        getsquad(data) {

            this.squad_ids = data.squad_id;
            this.mission_id = data.itemdata.id
            this.orgmissionpublish();
        },
        settime(val) {
            this.settimeitem = val;
            this.settimefrom.id = val.id;
            this.visiblesettime = true;
        },

        setmissioninfofunction(val) {
            this.setmissionfrom = val;
            this.setmissionfrom.id = val.id;

			console.log(this.setmissionfrom);
            this.visiblesetmissioninfo = true;
			this.getmissiontypelist();
        },

        /// 设置更改任务时间
        setmissiontime() {
            let _this = this;
            this.$confirm({
                title: "调整发布时间",
                content: "确认调整发布时间?",
                okText: "确认",
                cancelText: "取消",
                onOk: function () {

                    _this.spinning = true;
                    _this.$axios
                        .post("/api/BasicMission/setBasicMissionTime", {
                            data: {
                                mission_id: _this.settimefrom.id,
                                start_time: _this.settimefrom.start_time,
                                end_time: _this.settimefrom.end_time,
                            }
                        })
                        .then(res => {
                            if (res.code != 200) {
                                _this.$error({
                                    title: "错误",
                                    content: res.msg,
                                    okText: "确定"
                                });
                                _this.spinning = false;
                            } else {
                                _this.getChapterMission();
                                _this.spinning = false;
                            }
                        })
                        .catch(err => {
                            console.error(err);
                        });
                }
            });
            this.visiblesettime = false;
            this.settimeitem = [];


        },
		setmissionname() {
		    let _this = this;
			console.log(_this.setmissionfrom.id);
		    this.$confirm({
		        title: "修改任务名称",
		        content: "确认修改任务名称?",
		        okText: "确认",
		        cancelText: "取消",
		        onOk: function () {
		            _this.spinning = true;
					console.log(_this.setmissionfrom.id);
					
		            _this.$axios
		                .post("/api/BasicMission/updatemissnamename", {
		                    data: {
		                        mission_id: _this.setmissionfrom.id,
		                        name: _this.setmissionfrom.name,
								type_id: _this.setmissionfrom.type_id,
		                    }
		                })
		                .then(res => {
		                    if (res.code != 200) {
		                        _this.$error({
		                            title: "错误",
		                            content: res.msg,
		                        });
		                        _this.spinning = false;
								okText: "确定"
								_this.visiblesetmissioninfo = false;
								_this.setmissionfrom = [];
		                    } else {
								_this.visiblesetmissioninfo = false;
								 _this.spinning = false;
								//this.setmissionfrom = [];
		                        _this.getChapterMission();
		                       
								okText: "确定"
								
		                    }
		                })
		                .catch(err => {
		                    console.error(err);
		                });
		        }
		    });
		   
		_this.visiblesetmissioninfo = false;
		_this.spinning = false
		},

        setmissioninfoCancel() {
            this.visiblesetmissioninfo = false;
        },

        //设置时间的model 关闭
        settimehandleCancel() {
            this.visiblesettime = false;
        },
        handleChangegrade(value) {
            this.grade_id = value
            this.getBasicChapter();
        },
        handleChangesubject(value) {
            this.subject = value
            this.getBasicChapter();
        },
        handleChangesemester(value) {
            this.semester_id = value
            this.getBasicChapter();
        },
        getgrade() {
            this.$axios
                .post("/api/BasicGrade/index")
                .then((res) => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定",
                        });
                    } else {
                        this.gradelist = res.data.data;
                    }
                })
                .catch((err) => {
                    console.error(err);
                });

        },

        getsemester() {
            this.$axios
                .post("/api/BasicSemester/index")
                .then((res) => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定",
                        });
                    } else {
                        this.semesterlist = res.data.data;
                    }
                })
                .catch((err) => {
                    console.error(err);
                });

        },
        shengchengmission(id) {
            id;
            this.missionvisible = true;
        },
        ontestpaperPaginationChange(item) {
            console.log(item);
            this.testpaperpageinfo.current = item.current;
            this.getChapterTestpaper();
        },

        onmissionPaginationChange(item) {


            this.missionpageinfo.current = item.current;
            this.getChapterMission();
        },
        selectchapterItem(selectedKeys, e) {
            e;
            if (selectedKeys[0] != null) {
                this.chapter_id = selectedKeys[0];
				this.testpaperpageinfo.current=1;
                this.getChapterTestpaper();
                this.getChapterMission();
            }
        },
        changeTimeRange(val) {
            this.from.start_time = parseInt(val[0].valueOf() / 1000);
            this.from.end_time = parseInt(val[1].valueOf() / 1000);
        },

        changesetTimeRange(val) {
            this.settimefrom.start_time = parseInt(val[0].valueOf() / 1000);
            this.settimefrom.end_time = parseInt(val[1].valueOf() / 1000);
        },
        showmal(item) {
            this.visible = true;
            this.testpaper_id = item.id;
            this.testpaper_info = item;
            this.getgradelist();
            this.getmissiontypelist();
        },
        handleCancel() {
            this.visible = false;
        },
        handleCancelmission() {

            this.missionvisible = false;
        },
        okpostfrom() {
            this.postfrom();
            this.visible = false;
        },
        getBasicChapter() {
            this.$axios.post("/api/BasicChapter/gettreechapterbygrade", {
                data: {
                    'grade_id': this.grade_id,
                    'semester_id': this.semester_id,
                    'subject': this.subject,
                },
                pageinfo: this.testpaperpageinfo,
            })
                .then((res) => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定",
                        });
                    } else {
                        this.basicChapterList = res.data;
                    }
                })
                .catch((err) => {
                    console.error(err);
                });

        },
        // 发布任务 
        orgmissionpublish() {
            this.spinning = true;
            this.$axios
                .post("/api/BasicMission/orgmissionpublish", {
                    data: {
                        'mission_id': this.mission_id,
                        'squad_ids': this.squad_ids,
                    },
                })
                .then((res) => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定",
                        });
                        this.spinning = false;
                    } else {

                        if (res.data.lostsquadlist.length > 0) {

                            this.$notification.warning({
                                message: '此任务未完全生成',
                                description: "此任务有" + res.data.lostsquadlist.length +
                                    "个班级没有生成成功，因为班级内已经有相同的试卷",
                                duration: 0,
                            });
                        }

                        this.$message.success("操作成功");
                        this.getChapterMission();
                        this.spinning = false;
                    }
                })
                .catch((err) => {
                    console.error(err);
                });

        },

        //清空发布
        qingkong(mission_id) {
            let _this = this;
            this.$confirm({
                title: "清空发布任务",
                content: "确认清空当前任务的发布情况?",
                okText: "确认",
                cancelText: "取消",
                onOk: function () {
                    _this.$axios
                        .post("/api/BasicMission/clearorgmissionpublish", {
                            data: {
                                mission_id: mission_id,
                            }
                        })
                        .then(res => {
                            if (res.code != 200) {
                                _this.$error({
                                    title: "错误",
                                    content: res.msg,
                                    okText: "确定"
                                });
                            } else {
                                _this.getChapterMission();
                            }
                        })
                        .catch(err => {
                            console.error(err);
                        });
                }
            });
        },


        delmission(mission_id) {
            let _this = this;
            this.$confirm({
                title: "删除发布任务",
                content: "确认删除当前任务?",
                okText: "确认",
                cancelText: "取消",
                onOk: function () {
                    _this.$axios
                        .post("/api/BasicMission/delorgmission", {
                            data: {
                                mission_id: mission_id,
                            }
                        })
                        .then(res => {
                            if (res.code != 200) {
                                _this.$error({
                                    title: "错误",
                                    content: res.msg,
                                    okText: "确定"
                                });
                            } else {
                                _this.getChapterMission();
                            }
                        })
                        .catch(err => {
                            console.error(err);
                        });
                }
            });
        },

        getChapterTestpaper() {
            // this.chaptertestpaperlist=null;
            this.$axios
                .post("/api/BasicChapter/getchaptertestpaper", {
                    data: {
                        chapter_id: this.chapter_id,
                    },
                    pageinfo: this.testpaperpageinfo
                })
                .then((res) => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定",
                        });
                    } else {
                        this.chaptertestpaperlist = res.data.data;
                        this.testpaperpageinfo = res.data.pageinfo;
                    }
                })
                .catch((err) => {
                    console.error(err);
                });
        },

        getChapterMission() {
            // this.chaptertestpaperlist=null;
            this.$axios
                .post("/api/BasicMission/getchaptermission", {
                    data: {
                        'chapter_id': this.chapter_id,
                    },
                    pageinfo: this.missionpageinfo
                })
                .then((res) => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定",
                        });
                    } else {
                        this.chaptermissionlist = res.data.data;
                        this.missionpageinfo = res.data.pageinfo;
                        console.log(this.missionpageinfo)
                    }
                })
                .catch((err) => {
                    console.error(err);
                });
        },

        postfrom() {



            this.$axios
                .post("/api/BasicMission/orgaddmission", {
                    data: {
                        testpaper_id: this.testpaper_id,
                        mission_name: this.from.mission_name,
                        grade_id: this.from.grade_id,
                        start_time: this.from.start_time,
                        end_time: this.from.end_time,
                        islimit: this.islimit,
                        is_bind: this.testpaper_info.is_bind,
                        jcmission_name: this.testpaper_info.is_bind ? this.from.jcmission_name : "",
                        jc_shijuan_id: this.testpaper_info.is_bind ? this.from.jc_shijuan_id : "",
                        jsbzrgz: this.jsbzrgz,
                        mission_fbtype: this.from.mission_fbtype,
                        limit_time: this.from.limit_time,
                        type_id: this.from.type_id,
                        chapter_id: this.chapter_id,
                        tagname: this.from.tagname
                    },
                })
                .then((res) => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定",
                        });
                    } else {
                        this.getChapterTestpaper();
                        this.getChapterMission();
                        this.tab = '2';


                    }
                })
                .catch((err) => {
                    console.error(err);
                });
        },

        getgradelist() {
            this.$axios
                .post("/api/BasicGrade/index", {

                })
                .then((res) => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定",
                        });
                    } else {
                        this.gradelist = res.data.data;
                    }
                })
                .catch((err) => {
                    console.error(err);
                });
        },

        getmissiontypelist() {
            this.$axios
                .post("/api/BasicMissionType/index", {

                })

                .then((res) => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定",
                        });
                    } else {
                        this.missiontypelist = res.data.data;
                    }
                })
                .catch((err) => {
                    console.error(err);
                });
        },

        /* onSelect(selectedKeys, info) {
             console.log('selected', selectedKeys, info);
         }, */
        moment
    },
};
</script>
<style>
.active_btn {
    margin-left: 5px;
}
</style>
